import { Component, Input } from '@angular/core';

import { TranslationKeyMap } from './ca-score-section.i18n';

@Component({
    selector: 'cmps-ca-score-section',
    templateUrl: './ca-score-section.component.html',
    host: {
        class: 'cmps-ca-score-section',
    },
})
export class CaScoreSectionComponent {
    @Input() scorePercent: number;

    /** @private */
    _i18n = TranslationKeyMap;
}
